import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";

const CYCLE = ["en_attente", "validee", "confirmee"];
const statutColor = {
  en_attente: "#888780",
  validee: "#378ADD",
  devis_envoye: "#EF9F27",
  devis_accepte: "#7F77DD",
  confirmee: "#1D9E75",
  annulee: "#e53935",
};
const statutLabel = {
  en_attente: "En attente",
  validee: "Validée",
  devis_envoye: "Devis envoyé",
  devis_accepte: "Devis accepté",
  confirmee: "Confirmée",
  annulee: "Annulée",
};
const icones = {
  en_attente: "schedule",
  validee: "check",
  devis_envoye: "mail",
  devis_accepte: "task_alt",
  confirmee: "verified",
};

function TimelineCycle({ statut }) {
  if (statut === "annulee") {
    return (
      <MDBox display="flex" alignItems="center" gap={1} py={1.5} px={1}>
        <Icon sx={{ color: "#e53935" }}>cancel</Icon>
        <MDTypography variant="caption" sx={{ color: "#e53935", fontWeight: "bold" }}>
          Inscription annulée
        </MDTypography>
      </MDBox>
    );
  }
  const idxActuel = CYCLE.indexOf(statut);
  return (
    <MDBox display="flex" alignItems="flex-start" py={1.5} px={1}>
      {CYCLE.map((etape, i) => {
        const fait = i < idxActuel;
        const actuel = i === idxActuel;
        const couleur = statutColor[etape];
        const bgCercle = fait || actuel ? couleur : "#f0f0f0";
        const colCercle = fait || actuel ? "#fff" : "#bbb";
        return (
          <MDBox key={etape} sx={{ display: "flex", alignItems: "center", flex: i < CYCLE.length - 1 ? 1 : "0 0 auto" }}>
            <MDBox display="flex" flexDirection="column" alignItems="center" sx={{ minWidth: 64 }}>
              <MDBox
                sx={{
                  width: 28, height: 28, borderRadius: "50%",
                  bgcolor: bgCercle, color: colCercle,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  boxShadow: actuel ? "0 0 0 4px " + couleur + "33" : "none",
                  border: !fait && !actuel ? "1px solid #ddd" : "none",
                }}
              >
                <Icon sx={{ fontSize: "16px !important" }}>{fait ? "check" : icones[etape]}</Icon>
              </MDBox>
              <MDTypography
                variant="caption"
                sx={{ mt: 0.5, fontSize: "10px", textAlign: "center",
                  color: actuel ? couleur : "#999",
                  fontWeight: actuel ? "bold" : "normal", lineHeight: 1.1 }}
              >
                {statutLabel[etape]}
              </MDTypography>
            </MDBox>
            {i < CYCLE.length - 1 && (
              <MDBox sx={{ flex: 1, height: "2px", bgcolor: i < idxActuel ? statutColor[CYCLE[i + 1]] : "#e0e0e0", mt: "13px", minWidth: 16 }} />
            )}
          </MDBox>
        );
      })}
    </MDBox>
  );
}

export default TimelineCycle;
